import axios from "../axiosPlugin.js";

export const ticketSalesList = data => {
  return axios({
    url: "/api/report/voucherSalesReport",
    method: "get",
    data: { data },
  });
};